import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { BlobPdfDestroyAction, BlobPdfLoadAction } from '../../domains/blobPdfs/actions.types';

import { BlobPdfs } from './types';

export type BlobPdfAction = BlobPdfLoadAction | BlobPdfDestroyAction;

const initialState: BlobPdfs = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<BlobPdfs, BlobPdfAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'BLOB_PDF.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.blobPdf.id]: action.payload.blobPdf });
    case 'BLOB_PDF.LOAD_PENDING':
      return moveToPending(state, [action.payload.pdf.id]);
    case 'BLOB_PDF.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.pdf.id], action.payload.error);
    case 'BLOB_PDF.DESTROY':
      return remove(state, [action.payload.blobPdfId]);
    default:
      return state;
  }
};

export default reducer;
